/* NYGHT native sections — gallery, delivery estimate, description clamp. No dependencies. */
(() => {
  if (!customElements.get('nn-gallery')) {
    customElements.define('nn-gallery', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-track]');
        const rail = this.querySelector('[data-thumbs]');
        if (!track || !rail) return;
        const thumbs = [...rail.querySelectorAll('[data-go]')];
        const slides = [...track.children];
        thumbs.forEach((btn) => btn.addEventListener('click', () => {
          track.scrollTo({ left: slides[+btn.dataset.go].offsetLeft, behavior: 'smooth' });
        }));
        this.querySelectorAll('[data-step]').forEach((btn) => btn.addEventListener('click', () => {
          const i = Math.max(0, Math.min(slides.length - 1, current + +btn.dataset.step));
          track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        }));
        let current = 0;
        track.addEventListener('scroll', () => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (i === current || !thumbs[i]) return;
          current = i;
          thumbs.forEach((b, j) => b.classList.toggle('is-active', j === i));
          this.classList.toggle('is-past-first', i > 0);   // badge + gift card show on the first photo only (2026-10-10)
          const t = thumbs[i];
          if (t.offsetLeft < rail.scrollLeft || t.offsetLeft + t.offsetWidth > rail.scrollLeft + rail.clientWidth) {
            rail.scrollTo({ left: t.offsetLeft - rail.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
          }
          slides.forEach((s, j) => { const v = s.querySelector('video'); if (v && j !== i) v.pause(); });
        }, { passive: true });
      }
    });
  }

  if (!customElements.get('nn-compare')) {
    customElements.define('nn-compare', class extends HTMLElement {
      connectedCallback() {
        const range = this.querySelector('input[type=range]');
        range?.addEventListener('input', () => this.style.setProperty('--pos', `${range.value}%`));
      }
    });
  }

  const MONTHS =['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'];
  const addDays = (n, skipWeekends) => {
    const d = new Date();
    for (let c = 0; c < n;) { d.setDate(d.getDate() + 1); if (!skipWeekends || d.getDay() % 6) c++; }
    return d;
  };
  const fmt = (d) => `${d.getDate()}. ${MONTHS[d.getMonth()]}`;
  const initEta = (root = document) => root.querySelectorAll('[data-nn-eta]').forEach((el) => {
    const skip = el.dataset.skipWeekends === 'true';
    const min = addDays(+el.dataset.min, skip), max = addDays(+el.dataset.max, skip);
    el.textContent = +el.dataset.min === +el.dataset.max ? fmt(min) : `${fmt(min)} - ${fmt(max)}`;
  });

  const initClamp = (root = document) => root.querySelectorAll('[data-nn-clamp]').forEach((body) => {
    const inner = body.querySelector('.nn-acc__inner'), more = body.querySelector('.nn-acc__more');
    const limit = +body.dataset.nnClamp;
    const measure = () => {
      if (body.classList.contains('is-expanded')) return;
      const over = inner.scrollHeight > limit + 40;
      inner.style.maxHeight = over ? `${limit}px` : '';
      body.classList.toggle('is-clamped', over);
      more.hidden = !over;
    };
    more.onclick = () => { body.classList.add('is-expanded'); body.classList.remove('is-clamped'); inner.style.maxHeight = ''; more.hidden = true; };
    body.closest('details')?.addEventListener('toggle', measure);
    measure();
  });

  const init = (root) => { initEta(root); initClamp(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* Sticky add-to-cart bar (sections/nyght-sticky-atc.liquid). */
(() => {
  if (customElements.get('nn-sticky-atc')) return;
  customElements.define('nn-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      const idInput = this.querySelector('form [name=id]');
      this.querySelector('[data-nn-variant-select]')?.addEventListener('change', (e) => { if (idInput) idInput.value = e.target.value; });
      const qty = this.querySelector('.nn-qty__input');
      this.querySelectorAll('[data-qty-step]').forEach((btn) => btn.addEventListener('click', () => {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + +btn.dataset.qtyStep);
      }));
      if (this.hasAttribute('data-bundle-sync')) this.bundleSync(idInput, qty);
      // Same rule as the GemPages sticky: show once the main add-to-cart button has scrolled away above.
      const trigger = document.querySelector(this.dataset.trigger);
      if (!trigger) { this.classList.add('is-visible'); return; }
      new IntersectionObserver(([entry]) => {
        this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(trigger);
    }

    /* Kaching Bundles owns the buy box's form: it adds the free gift and its deal properties only when that form is
       submitted. The bar's own form went straight to /cart/add, so sticky adds had no gift. When a Kaching block
       is on the page, the bar selects the same variant in Kaching, presses the buy box button, then applies its
       quantity to the line Kaching added (Kaching forces the deal bar's quantity). Kaching's selects also update
       the bar, so both always show the same variant. */
    bundleSync(idInput, qty) {
      const select = this.querySelector('[data-nn-variant-select]');
      const bar = () => {
        const checked = document.querySelector('.kaching-bundles__bar input[type=radio]:checked');
        return (checked && checked.closest('.kaching-bundles__bar')) || document.querySelector('.kaching-bundles__bar');
      };
      const barSelects = (b) => [...(b ? b.querySelectorAll('select.kaching-bundles__bar-variant-select') : [])]
        .filter((s) => !s.closest('.kaching-bundles__free-gift'));
      const setSelect = (el, value) => {
        if (el.value === value || ![...el.options].some((o) => o.value === value)) return;
        el.value = value;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      };
      let giftTouched = false;

      document.addEventListener('change', (e) => {
        const t = e.target;
        if (!t.matches || !t.matches('select.kaching-bundles__bar-variant-select')) return;
        if (t.closest('.kaching-bundles__free-gift')) { if (e.isTrusted) giftTouched = true; return; }
        if (!select) return;
        const key = barSelects(t.closest('.kaching-bundles__bar')).map((s) => s.value).join('|');
        const opt = [...select.options].find((o) => o.dataset.options === key);
        if (!opt || select.value === opt.value) return;
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));   // updates the id input and the bar price
      });

      this.addEventListener('submit', async (e) => {
        if (this.nativeSubmit) { this.nativeSubmit = false; return; }   // fallback below: let product-form handle it
        const mainBtn = document.querySelector(this.dataset.trigger);
        if (!document.querySelector('.kaching-bundles__bar') || !mainBtn || !mainBtn.form) return;   // no live Kaching deal → plain product-form submit
        e.preventDefault();
        e.stopImmediatePropagation();
        const btn = this.querySelector('[type=submit]');
        if (btn.classList.contains('loading')) return;
        btn.classList.add('loading');
        btn.querySelector('.loading__spinner')?.classList.remove('hidden');
        const variantId = idInput ? idInput.value : '';
        const want = Math.max(1, parseInt(qty && qty.value, 10) || 1);
        try {
          const b = bar();
          const opt = select && select.selectedOptions[0];
          if (opt && opt.dataset.options) {
            const values = opt.dataset.options.split('|');
            barSelects(b).forEach((s, i) => values[i] && setSelect(s, values[i]));
            // No gift picker in the bar, so match the gift's size to the duvet unless the shopper chose one.
            if (!giftTouched && b) b.querySelectorAll('.kaching-bundles__free-gift select').forEach((s) => values.forEach((v) => setSelect(s, v)));
          }
          const formId = () => (mainBtn.form.querySelector('[name=id]') || {}).value;
          for (let i = 0; i < 20 && variantId && formId() !== variantId; i++) await new Promise((r) => setTimeout(r, 50));
          if (variantId && formId() !== variantId) throw new Error('Kaching did not take the variant');

          const mainLine = (cart) => cart.items.find((item) => {
            if (String(item.variant_id) !== String(variantId)) return false;
            try { return JSON.parse((item.properties || {}).__kaching_bundles || '{}').main; } catch (_) { return false; }
          });
          const before = mainLine(await (await fetch('/cart.js')).json());
          const had = before ? before.quantity : 0;
          mainBtn.click();
          if (want > 1) {
            let line;
            for (let i = 0; i < 40 && !(line && line.quantity > had); i++) {
              await new Promise((r) => setTimeout(r, 250));
              line = mainLine(await (await fetch('/cart.js')).json());
            }
            if (line && line.quantity > had) {
              await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: line.key, quantity: line.quantity + want - 1 }) });
              window.kachingCartApi?.refreshCart?.();
              window.nyghtCart?.refresh(true);
            }
          }
        } catch (err) {
          // Anything unexpected: fall back to the bar's own form, so the shopper still gets the product.
          console.warn('nn-sticky-atc bundle sync:', err);
          this.nativeSubmit = true;
          e.target.dispatchEvent(new Event('submit', { bubbles: false, cancelable: true }));
        } finally {
          btn.classList.remove('loading');
          btn.querySelector('.loading__spinner')?.classList.add('hidden');
          if (qty) qty.value = 1;
        }
      }, true);
    }
  });
})();

/* Buy-box variant dropdown (nyght-main-product "variant_picker" block): updates the add-to-cart form, price,
   stock text and the ?variant= URL. Sticky bar dropdown keeps its own price in sync. */
(() => {
  const syncMain = (select) => {
    const opt = select.selectedOptions[0];
    if (!opt) return;
    const root = select.closest('.nn-pdp') || document;
    const form = document.getElementById(select.dataset.nnVariantPicker);
    const idInput = form && form.querySelector('[name=id]');
    if (idInput) idInput.value = opt.value;
    root.querySelectorAll('[data-nn-price]:not([data-fixed])').forEach((el) => { el.textContent = opt.dataset.price; });
    root.querySelectorAll('[data-nn-compare]').forEach((el) => { el.textContent = opt.dataset.compare; el.hidden = !opt.dataset.compare; });
    const available = opt.dataset.available === 'true';
    const btn = form && form.querySelector('[type=submit]');
    if (btn) btn.toggleAttribute('disabled', !available);
    root.querySelectorAll('[data-nn-stock]').forEach((el) => {
      const label = el.querySelector('[data-nn-stock-label]');
      if (label) label.textContent = available ? el.dataset.in : el.dataset.out;
    });
    const url = new URL(window.location.href);
    url.searchParams.set('variant', opt.value);
    window.history.replaceState({}, '', url);
  };
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t.matches) return;
    if (t.matches('[data-nn-variant-picker]')) {
      syncMain(t);
      // keep the sticky bar on the same variant, so it never adds a different size than the one chosen above
      document.querySelectorAll('[data-nn-variant-select]').forEach((s) => {
        if (s.value !== t.value && [...s.options].some((o) => o.value === t.value)) {
          s.value = t.value; s.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    if (t.matches('[data-nn-variant-select]')) {
      const price = t.closest('nn-sticky-atc')?.querySelector('[data-nn-sticky-price]');
      const opt = t.selectedOptions[0];
      if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
    }
  });
})();

/* Stock count block follows the variant dropdown. */
document.addEventListener('change', (e) => {
  const t = e.target;
  if (!t.matches || !t.matches('[data-nn-variant-picker]')) return;
  const opt = t.selectedOptions[0];
  const root = t.closest('.nn-pdp') || document;
  root.querySelectorAll('[data-nn-inventory]').forEach((el) => {
    const label = el.querySelector('[data-nn-inventory-label]');
    const qty = parseInt(opt && opt.dataset.qty, 10);
    if (!label || Number.isNaN(qty)) return;
    const high = parseInt(el.dataset.threshold, 10) || 0;
    const tpl = high > 0 && qty > high && el.dataset.high ? el.dataset.high : el.dataset.template;
    const out = qty > 0 ? tpl.replace('[count]', qty).replace('[variant]', opt.text.trim()) : el.dataset.out;
    label.replaceChildren(...out.split('**').map((part, i) => {
      if (i % 2 === 0) return document.createTextNode(part);
      const b = document.createElement('b'); b.textContent = part; return b;
    }));
  });
});

/* NYGHT native — accordions that keep one question open ([data-nn-single-open]) and autoplaying image rows ([data-nn-autoplay]). */
(() => {
  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.open) return;
    const scope = item.closest('[data-nn-single-open]');
    if (!scope) return;
    scope.querySelectorAll('details[open]').forEach((other) => { if (other !== item) other.open = false; });
  }, true);

  document.querySelectorAll('[data-nn-autoplay]').forEach((track) => {
    const delay = Number(track.dataset.nnAutoplay) || 4000;
    let paused = false;
    ['pointerdown', 'touchstart', 'mouseenter'].forEach((type) => track.addEventListener(type, () => { paused = true; }, { passive: true }));
    track.addEventListener('mouseleave', () => { paused = false; });
    setInterval(() => {
      if (paused || document.hidden) return;
      const slide = track.firstElementChild;
      if (!slide) return;
      const step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || '0');
      const end = track.scrollWidth - track.clientWidth - 2;
      track.scrollTo({ left: track.scrollLeft + step > end ? 0 : track.scrollLeft + step, behavior: 'smooth' });
    }, delay);
  });
})();


/* NYGHT native — variant tiles ([data-nn-vt]): one button group per option drives the hidden variant select,
   so price, stock line, sold-out state and the ?variant= URL all go through the existing picker sync. */
(() => {
  const refresh = (root) => {
    const select = root.querySelector('[data-nn-variant-picker]');
    const opts = [...select.options];
    const groups = [...root.querySelectorAll('.nn-vt__group')];
    const chosen = groups.map((g) => g.querySelector('.nn-vt__opt.is-on')?.dataset.value);
    groups.forEach((g, gi) => {
      g.querySelectorAll('.nn-vt__opt').forEach((btn) => {
        const want = chosen.slice(); want[gi] = btn.dataset.value;
        const hit = opts.find((o) => want.every((v, k) => v === undefined || o.dataset['o' + (k + 1)] === v));
        btn.classList.toggle('is-out', !hit || hit.dataset.available !== 'true');
      });
    });
    return opts.find((o) => chosen.every((v, k) => v === undefined || o.dataset['o' + (k + 1)] === v));
  };
  document.querySelectorAll('[data-nn-vt]').forEach(refresh);
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('.nn-vt__opt');
    if (!btn) return;
    const root = btn.closest('[data-nn-vt]');
    btn.closest('.nn-vt__row').querySelectorAll('.nn-vt__opt').forEach((b) => {
      b.classList.toggle('is-on', b === btn); b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
    });
    const match = refresh(root);
    if (!match) return;
    const select = root.querySelector('[data-nn-variant-picker]');
    select.value = match.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();


/* Photo label stock line ([data-nn-photo-stock]) follows the variant picker (2026-10-01). */
document.addEventListener('change', (e) => {
  const t = e.target;
  if (!t.matches || !t.matches('[data-nn-variant-picker]')) return;
  const opt = t.selectedOptions[0]; const root = t.closest('.nn-pdp') || document;
  root.querySelectorAll('[data-nn-photo-stock]').forEach((el) => {
    const line = el.querySelector('[data-nn-photo-stock-text]'); if (!line || !opt) return;
    const qty = parseInt(opt.dataset.qty, 10); const low = parseInt(el.dataset.low, 10) || 0;
    if (Number.isNaN(qty)) return;
    line.textContent = qty > 0 ? el.dataset.tpl.replace('[count]', qty) : el.dataset.out;
    line.hidden = qty > 0 && low > 0 && qty > low;
  });
});
